import * as React from 'react';
import { createRoot } from 'react-dom/client';

import CustomDashboard from '@/pages/CustomDashboard';
import { renderWithUiRoot, resolveReactMountContainer } from '@/js/wisemetering/ui/render_with_ui_root';

WiseMetering.Views.CustomDashboard = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function() {
        this.reactContainer = resolveReactMountContainer(this);
        this.reactRoot = createRoot(this.reactContainer);
        renderWithUiRoot(this.reactRoot, this.reactContainer, <CustomDashboard/>);
    },

    onClose: function() {
        if (this.reactRoot) {
            this.reactRoot.unmount(); // Unmount the React component
            this.reactRoot = null; // Clean up reference
            this.reactContainer = null;
        }
    }
});
